import { render } from "./uploader-base.vue?vue&type=template&id=27bc49fa"
import script from "./uploader-base.vue?vue&type=script&lang=js"
export * from "./uploader-base.vue?vue&type=script&lang=js"

import "./uploader-base.vue?vue&type=style&index=0&id=27bc49fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__